export class ExpandingCircle extends Phaser.GameObjects.Graphics {
    constructor(scene, x, y) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = y;

        // Initial configuration for the circle (stroke style, line width, color)
        this.lineWidth = 2;
        //this.fillStyle(0xFFFF00, 0);  // Fill color (yellow), but fully transparent
        //this.strokeStyle(0xFFFF00, 1); // Stroke color yellow with alpha 1
        this.radius = 10;

        // Draw the initial circle
        this.drawCircle();

        // Add this Graphics object to the scene
        scene.add.existing(this);

        // Tween to animate the circle expanding and fading
        this.scene.tweens.add({
            targets: this,
            radius: 50,          // Expand to double the size
            alpha: 0,            // Fade out to alpha 0
            duration: 700,       // Animation duration (500ms)
            ease: 'Power2',      // Easing function
            onUpdate: () => {
                this.clear();    // Clear the previous graphics
                this.drawCircle(); // Redraw the circle with updated radius and alpha
            },
            onComplete: () => {
                this.destroy();   // Destroy the object once the animation is complete
            }
        });
    }

    // Function to draw the circle
    drawCircle() {
        this.lineStyle(this.lineWidth, 0xFFFF00, this.alpha);  // Yellow stroke with current alpha
        this.strokeCircle(0, 0, this.radius);  // Draw a circle at (0, 0) with the current radius
    }
}